import { z } from 'zod';
/** The pool policy (12+, upper, lower, digit, symbol), checked before the round trip. */
export const PASSWORD_HINT = 'At least 12 characters with upper and lower case, a number and a symbol.';
export const passwordSchema = z
    .string()
    .min(12, 'Use at least 12 characters')
    .regex(/[a-z]/, 'Add a lower-case letter')
    .regex(/[A-Z]/, 'Add an upper-case letter')
    .regex(/\d/, 'Add a number')
    .regex(/[^A-Za-z0-9]/, 'Add a symbol');
export const emailSchema = z.email('Enter a valid email address');
export const totpCodeSchema = z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Enter the 6-digit code');
/** Every form with a password pair: the confirmation repeats the password (`.refine(...PASSWORDS_MATCH)`). */
export const PASSWORDS_MATCH = [(v) => v.password === v.confirm, { message: 'The passwords do not match', path: ['confirm'] }];
export const newPasswordForm = z
    .object({ password: passwordSchema, confirm: z.string() })
    .refine(...PASSWORDS_MATCH);
//# sourceMappingURL=password-rules.js.map